import React from 'react';
import styles from './PageHeading.module.css';

const PageHeading = ({ children, className }) => {
  return (
    <h1 className={`${styles.pageHeading} ${className || ''}`}>
      {children}
    </h1>
  );
};

export default PageHeading; 